// Lichess's replay speed range, slow → fast.
export const AUTOPLAY_SPEEDS = [
  {label: 'Slow', ms: 5000},
  {label: 'Normal', ms: 2000},
  {label: 'Fast', ms: 1000},
  {label: 'Rapid', ms: 500},
];
